module.exports = __webpack_public_path__ + "img/小程序-封面.f63b4cb2.png";